export default __webpack_public_path__ + "static/media/icon-ranking-2.2fa4964e.svg";